import axios from 'axios';

let BASE_URL = process.env.REACT_APP_INT_URL;

const mikrokomReq = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json'
    }
});

const loginMikrokom = async (username, password, domainCode) => {
    const response = await mikrokomReq.post('/mikrokom-altos/login', { username, password, domainCode });
    return response;
};

const getCompanyAndPeriodList = async (token) => {
    const response = await mikrokomReq.post('/mikrokom-altos/getCompaniesAndPeriods', { token });
    return response;
};

const getReceiptList = async (token, periodId, companyId, startDate, endDate) => {
    const response = await mikrokomReq.post('/mikrokom-altos/getReceiptList', { token, periodId, companyId, startDate, endDate });
    return response;
};

const sendReceipt = async (data) => {
    const response = await mikrokomReq.post('/mikrokom-altos/sendReceipt', data);
    return response;
};

const getReceiptEnvanter = async (data) => {
    const response = await mikrokomReq.post('/mikrokom-altos/getReceiptEnvanter', data);
    return response;
};

const sendReceiptEnvanter = async (data) => {
    const response = await mikrokomReq.post('/mikrokom-altos/sendReceiptEnvanter', data);
    return response;
};

export { loginMikrokom, getCompanyAndPeriodList, getReceiptList, sendReceipt, getReceiptEnvanter, sendReceiptEnvanter };
